<template>
  <div class="plan-summary-line">
    <div class="name">{{name}}</div>
    <div class="amount-and-menu-item-container">
      <div class="amount" :class="{ 'menu-item-shown': showMenuItem }">{{ formattedAmount }}<span> ₪</span></div>
      <div class="menu-icon">
        <icon v-if="showMenuItem" icon-name="more_vert" :color="menuColor" @click="$emit('plan-menu-clicked')"/>
      </div>
    </div>
  </div>
</template>

<script>
import moneyUtils from '@/utils/money';
import BaseUi from 'base-ui';

export default {
  name: 'PlanSummaryLine',
  components: {
    Icon: BaseUi.Icon,
  },
  data() {
    return {
      menuColor: BaseUi.Colors.riseupBlack,
    };
  },
  props: {
    name: {
      type: String,
      require: true,
    },
    amount: {
      type: Number,
      require: true,
    },
    showMenuItem: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedAmount() {
      return moneyUtils.formatAmountWithFraction(this.amount, 0);
    },
  },
};
</script>

<style scoped lang="scss">
  .plan-summary-line {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding: 0 30px;

    .amount-and-menu-item-container {
      display: flex;
      align-items: center;
    }

    .amount.menu-item-shown {
      padding-left: 24px;
    }

    .menu-icon {
      cursor: pointer;
    }
}
</style>
